module.exports = __webpack_public_path__ + "static/img/start-info.7fcbe22e.png";